var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDepartureIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.47806 7.63199L4.96806 0.559992L6.89906 0.0419922L13.8501 6.46199L19.1121 5.05199C19.4964 4.94909 19.9058 5.00306 20.2503 5.20204C20.5948 5.40101 20.8462 5.72869 20.9491 6.11299C21.052 6.49729 20.998 6.90673 20.799 7.25123C20.6 7.59574 20.2724 7.84709 19.8881 7.94999L4.91606 11.96L4.14006 9.06199L4.38106 8.99699L6.84806 11.442L4.22206 12.146C4.00673 12.2037 3.77828 12.1879 3.573 12.1009C3.36772 12.0139 3.19739 11.8608 3.08906 11.666L0.466064 6.93999L1.91506 6.55199L4.38106 8.99699L9.47806 7.63099V7.63199ZM3.00006 15H19.0001V17H3.00006V15Z",
    fill: "#5F6B7A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartureIcon);
export default __webpack_public_path__ + "static/media/departure-icon.f30343713b5bfa2ec5c13647aeb5459c.svg";
export { ForwardRef as ReactComponent };